import { createContext } from 'react';

const startupContext = createContext();

export default startupContext;